import { render, staticRenderFns } from "./search_list.vue?vue&type=template&id=564f4020&scoped=true&"
import script from "./search_list.vue?vue&type=script&lang=js&"
export * from "./search_list.vue?vue&type=script&lang=js&"
import style0 from "./search_list.vue?vue&type=style&index=0&id=564f4020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f4020",
  null
  
)

export default component.exports